import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled.label`
  font-size: ${({ theme }) => theme?.fonts?.label['font-size']};
  line-height: ${({ theme }) => theme?.fonts?.label['line-height']};
  font-weight: ${({ theme }) => theme?.fonts?.label['font-weight']};
  color: ${({ theme }) => theme?.colors?.common?.black};
  text-align: left;
  margin-bottom: 5px;
`;

export const Box = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme?.colors?.border?.default};
  border-radius: ${({ theme }) => theme?.borders?.input};
  padding: 12px 8px;
  gap: 12px;

  & input {
    border: none;
    outline: none;
    width: ${({ type }) => (type === 'password' ? '90%' : '100%')};
    height: 100%;
    font-size: ${({ theme }) => theme?.fonts?.label['font-size']};
    line-height: ${({ theme }) => theme?.fonts?.label['line-height']};
    font-weight: ${({ theme }) => theme?.fonts?.label['font-weight']};
    color: ${({ theme }) => theme?.colors?.common?.black};
    background-color: transparent;
  }

  &:has(input:focus) {
    border-color: #228be6 !important;
  }

  &.error:has(input:focus) {
    border-color: red !important;
  }

  & input::placeholder {
    color: ${({ theme }) => theme?.colors?.border?.default};
  }

  & input:focus {
    border-color: blue !important;
  }

  & button {
    width: 10%;
    height: 100%;
    outline: none;
    border: none;
    background: none;
    cursor: pointer !important;
    display: flex;
    justify-content: flex-end;

    svg {
      font-size: 18px;
      color: ${({ theme }) => theme?.colors?.border?.default};
    }
  }
`;
